import React, { useEffect, useState } from 'react'
import queryString from 'query-string'
import { useDispatch, useSelector } from 'react-redux'
import Loader from 'srcReact/components/common2/Loader'
import Button from 'srcReact/components/common2/Button'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Spinner from 'srcReact/components/common2/Spinner'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { integrationActions } from 'srcReact/Pages/IntegrationSettings/actions'

function SaveConnection() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [connectionEstablished, setConnectionEstablished] = useState('')
  const [loadingCalendarMessage, setLoadingCalendarMessage] = useState('')
  const [type, setType] = useState('')
  const {
    integration: {
      eventData,
      loading: addMixrLoading,
      thirdPartyconnection: { API_connection, connection_saved, id_external_api_auth, loading }
    }
  } = useSelector((state) => state)

  const getType = () => {
    if (location.pathname.includes('gcalAddEvent')) {
      setType('google')
      return 'google'
    } else if (location.pathname.includes('mcalAddEvent')) {
      setType('microsoft')
      return 'microsoft'
    } else if (location.pathname.includes('zoomConnect')) {
      setType('zoom')
      return 'zoom'
    }
  }

  useEffect(() => {
    const calendarInfo = localStorage.getItem('addtocal')
    //default_integration is saved on integration settings page
    let defaultSetting = 1
    if (localStorage.getItem('default_integration') !== null) {
      defaultSetting = JSON.stringify(localStorage.getItem('default_integration')) ? 1 : 0
    }
    let queryParams = queryString.parse(location.search)
    const code = queryParams?.code
    let setUseForCalendar = 0
    let setAddToCalendarDefault = 0
    let setUseForMeeting = 0
    let setMeetingDefault = 0
    if (calendarInfo) {
      setUseForCalendar = defaultSetting
      setAddToCalendarDefault = defaultSetting
    } else {
      setUseForMeeting = defaultSetting
      setMeetingDefault = defaultSetting
    }
    const type = getType()
    if (code) {
      const organizationId = getCurrentOrgId()
      dispatch(
        integrationActions.saveExternalAPIToken(
          type,
          code,
          setUseForCalendar,
          setUseForMeeting,
          setAddToCalendarDefault,
          setMeetingDefault,
          organizationId
        )
      )
    }
  }, [])

  useEffect(() => {
    if (!loading && API_connection && connection_saved && id_external_api_auth) {
      localStorage.setItem('id_external_api_auth', id_external_api_auth)
      const calendarInfo = localStorage.getItem('addtocal')
      const integration_from = localStorage.getItem('integration_from')
      setConnectionEstablished(true)
      //do not save event to calendar, if connection is coming from integration settings page.
      if (calendarInfo) {
        localStorage.removeItem('addtocal')
        if (integration_from !== 'integration_settings') {
          localStorage.removeItem('integration_from')
          const calInfo = calendarInfo.split('|')
          const recurrenceUpdate = calInfo.length === 3 ? calInfo[2] : 'unique'
          setLoadingCalendarMessage('Adding an event to the calendar...')
          dispatch(
            integrationActions.postEventToCalendar(calInfo[0], calInfo[1], id_external_api_auth, recurrenceUpdate)
          )
        }
      }
      if (localStorage.getItem('default_integration')) {
        localStorage.removeItem('default_integration')
      }
    }
  }, [loading, API_connection, id_external_api_auth, connection_saved])

  useEffect(() => {
    if (!addMixrLoading && eventData) {
      setLoadingCalendarMessage('')
    }
  }, [eventData, addMixrLoading])

  const closeWindow = () => {
    window.close()
  }
  return loading ? (
    <Loader />
  ) : connectionEstablished ? (
    <div className={styles.success}>
      <img src={config.assetUrl + '/images/check.png'} alt='' />
      <h1 className={styles.title}>
        {t(`event.create.venue.connectionSuccess`, { option: type.charAt(0).toUpperCase() + type.slice(1) })}
      </h1>
      <h2 className={styles.subtitle}>
        {loadingCalendarMessage ? loadingCalendarMessage : t('event.create.venue.connectionSuccessSubtitle')}
      </h2>
      {loadingCalendarMessage ? (
        <Spinner />
      ) : (
        <Button customStyle={styles.button} handleClick={closeWindow} text={t('global.alert_close')} />
      )}
    </div>
  ) : null
}

export default SaveConnection
